import { LEGAL_ADMIN, LEGAL_DOCUMENT_EFFECTIVE_DATE, LEGAL_DOCUMENT_VERSION } from './constants'
import type { LegalDocumentContent } from './types'

export const rulesContent: LegalDocumentContent = {
  slug: 'rules',
  documentTitle: 'Правила сообщества',
  h1: 'Правила сообщества',
  version: LEGAL_DOCUMENT_VERSION,
  effectiveDate: LEGAL_DOCUMENT_EFFECTIVE_DATE,
  intro: [
    `Площадка «${LEGAL_ADMIN.brandName}» (${LEGAL_ADMIN.siteHost}) — социальная сеть / форум для проектов, команд и обсуждений.`,
    `Площадку ведёт ${LEGAL_ADMIN.displayName} (далее — «Администрация»). Это не коммерческая организация и не юридическое лицо.`,
    'Регистрируясь или используя площадку, вы подтверждаете, что прочитали эти Правила, понимаете их и принимаете. Если не согласны — не пользуйтесь сервисом.',
  ],
  sections: [
    {
      id: 'about',
      title: '1. О площадке',
      paragraphs: [
        'Сервис даёт возможность создавать профили, публиковать проекты и команды, оставлять комментарии, работать с соц-заказами и получать уведомления.',
        'Часть функций доступна только после входа и заполнения профиля.',
      ],
    },
    {
      id: 'account',
      title: '2. Аккаунт',
      bullets: [
        'Пользоваться площадкой могут лица от 18 лет.',
        'Вход — по email с одноразовым кодом (или по паролю, если он включён для аккаунта).',
        'Вы отвечаете за сохранность доступа к своему email и за все действия под своим аккаунтом.',
        'Не создавайте аккаунты от чужого имени и не передавайте доступ третьим лицам.',
      ],
    },
    {
      id: 'allowed',
      title: '3. Что можно',
      paragraphs: [
        'Публиковать проекты, команды, комментарии и соц-заказы в рамках закона и этих Правил; общаться уважительно; пользоваться жалобами при нарушениях.',
      ],
    },
    {
      id: 'forbidden',
      title: '4. Что нельзя',
      bullets: [
        'спам, массовая реклама, навязчивые сообщения;',
        'оскорбления, травля, угрозы, разжигание ненависти;',
        'незаконный контент и призывы к противоправным действиям;',
        'публикация чужих персональных данных без согласия;',
        'выдача себя за другого человека или организацию;',
        'попытки взлома, обхода ограничений, повреждения работы сайта.',
      ],
    },
    {
      id: 'content',
      title: '5. Контент',
      paragraphs: [
        'Материалы, которые вы публикуете, остаются вашими. Размещая их, вы даёте Администрации право хранить и показывать их в рамках работы площадки.',
        'Вы гарантируете, что имеете право публиковать материал и что он не нарушает закон и права других людей.',
        'Администрация не обязана проверять весь контент заранее и не отвечает за высказывания и материалы пользователей в пределах, допустимых законом.',
      ],
    },
    {
      id: 'moderation',
      title: '6. Модерация и жалобы',
      paragraphs: [
        'Вы можете пожаловаться на пользователя, проект или комментарий через интерфейс площадки.',
        'Жалобы рассматриваются вручную. Администрация может ограничить функции, скрыть контент или заблокировать аккаунт при нарушении Правил или закона.',
        'Злоупотребление жалобами тоже может повлечь ограничения.',
      ],
    },
    {
      id: 'notifications',
      title: '7. Уведомления',
      bullets: [
        'In-app уведомления о событиях в аккаунте.',
        'Письма на email — если включены в настройках.',
        'Web-push — только если вы разрешили их в браузере.',
      ],
    },
    {
      id: 'as-is',
      title: '8. Сервис «как есть» и риски',
      paragraphs: [
        'Площадка предоставляется бесплатно и «как есть», без гарантий бесперебойной работы, полной сохранности данных или отсутствия ошибок.',
        'Передача информации через интернет небезопасна на 100%. Возможны сбои, взлом, утечки и иные нештатные ситуации — в том числе по причинам вне контроля Администрации.',
        'Пользуясь сервисом, вы осознанно принимаете эти риски. Не размещайте на площадке данные, утрата или раскрытие которых для вас критичны.',
        'Администрация принимает разумные меры защиты, но не обещает абсолютную безопасность.',
      ],
    },
    {
      id: 'liability',
      title: '9. Ограничение ответственности',
      paragraphs: [
        'В пределах, допустимых законом, Администрация не отвечает за косвенный ущерб, упущенную выгоду, потерю данных или убытки из‑за использования или невозможности использовать площадку.',
        'Вы сами несёте ответственность за своё поведение, контент и соблюдение закона при использовании сервиса.',
        'Ничто в этих Правилах не исключает ответственность, которую нельзя ограничить по закону.',
      ],
    },
    {
      id: 'privacy-ref',
      title: '10. Данные и cookie',
      paragraphs: [
        'Как обрабатываются данные — см. раздел [[privacy|Конфиденциальность]].',
        'Как используются cookie — см. раздел [[cookies|Cookie]].',
        'Администрация не продаёт персональные данные и не передаёт их третьим лицам в маркетинговых целях. Технические партнёры (хостинг, доставка писем) могут получать данные только для работы сайта.',
      ],
    },
    {
      id: 'changes',
      title: '11. Изменения',
      paragraphs: [
        'Администрация может обновлять Правила. Актуальная редакция публикуется на этой странице с датой. Продолжение использования площадки после публикации означает согласие с новой редакцией.',
      ],
    },
    {
      id: 'contact',
      title: '12. Контакт',
      paragraphs: [
        `${LEGAL_ADMIN.displayName}. Email: ${LEGAL_ADMIN.contactEmail}.`,
      ],
    },
  ],
  relatedLinks: [
    { label: 'Конфиденциальность', slug: 'privacy' },
    { label: 'Cookie', slug: 'cookies' },
  ],
}
